import cssUtil from 'gw-portals-util-js/CssUtil';

import styles from './IndustryCode-hashed.scss';
import template from 'text!./IndustryCode.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            match: '=',
            query: '='
        },
        template: cssUtil.hashTemplate(template, styles)
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/IndustryCode/IndustryCode.js
// module id = 324
// module chunks = 0